(function () {
  var form = document.querySelector('[data-gh-form]');
  var configEl = document.querySelector('[data-gh-config]');
  if (!form || !configEl) return;

  var config = JSON.parse(configEl.textContent);
  var variants = config.variants;
  var slabIndex = config.slabIndex;
  var minQty = Math.max(1, parseInt(config.minQty, 10) || 1);

  var qtyInput = form.querySelector('[data-gh-qty]');
  var variantInput = form.querySelector('[data-gh-variant-id]');
  var submitBtn = form.querySelector('[data-gh-submit]');
  var errorBox = form.querySelector('[data-gh-error]');
  var slabTable = form.querySelector('[data-gh-slab-table]');
  var hintBox = form.querySelector('[data-gh-hint]');
  var unitPriceEls = document.querySelectorAll('[data-gh-unit-price]');
  var totalEl = form.querySelector('[data-gh-total]');
  var buttonText = submitBtn.innerHTML;

  // ---------- Money ----------
  function formatNumber(n, decimals, thousands, decimal) {
    var parts = n.toFixed(decimals).split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
    return parts.join(decimal);
  }

  function formatMoney(cents) {
    var amount = cents / 100;
    return config.moneyFormat.replace(/\{\{\s*(\w+)\s*\}\}/, function (match, key) {
      switch (key) {
        case 'amount_no_decimals': return formatNumber(amount, 0, ',', '.');
        case 'amount_with_comma_separator': return formatNumber(amount, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return formatNumber(amount, 0, '.', ',');
        default: return formatNumber(amount, 2, ',', '.');
      }
    });
  }

  // ---------- Slabs (e.g. "1-24", "25-99", "100+") ----------
  var slabs = [];
  if (slabIndex >= 0) {
    variants.forEach(function (variant) {
      var value = variant.options[slabIndex];
      if (slabs.some(function (s) { return s.value === value; })) return;
      var match = String(value).match(/\d+/);
      slabs.push({ value: value, min: match ? parseInt(match[0], 10) : 0 });
    });
    slabs.sort(function (a, b) { return a.min - b.min; });
  }

  function slabFor(qty) {
    var current = slabs[0];
    slabs.forEach(function (slab) {
      if (qty >= slab.min) current = slab;
    });
    return current;
  }

  // ---------- Variant lookup ----------
  function chosenOptions(slabValue) {
    var count = variants[0].options.length;
    var options = [];
    for (var i = 0; i < count; i++) {
      if (i === slabIndex) {
        options.push(slabValue);
        continue;
      }
      var checked = form.querySelector('[data-gh-option="' + i + '"]:checked');
      options.push(checked ? checked.value : variants[0].options[i]);
    }
    return options;
  }

  function findVariant(options) {
    return variants.find(function (variant) {
      return variant.options.every(function (value, i) { return value === options[i]; });
    });
  }

  function getQty() {
    return Math.max(0, parseInt(qtyInput.value, 10) || 0);
  }

  // ---------- Pricing UI ----------
  function update() {
    var qty = getQty();
    var slab = slabs.length ? slabFor(qty) : null;
    var variant = findVariant(chosenOptions(slab ? slab.value : null));

    if (variant) {
      variantInput.value = variant.id;
      unitPriceEls.forEach(function (el) { el.innerHTML = formatMoney(variant.price); });
      totalEl.innerHTML = formatMoney(variant.price * qty);
      submitBtn.disabled = !variant.available;
      submitBtn.innerHTML = variant.available ? buttonText : config.strings.unavailable;
    } else {
      submitBtn.disabled = true;
      submitBtn.innerHTML = config.strings.notFound;
      console.warn('[gift-hamper] No variant for options', chosenOptions(slab ? slab.value : null), 'slab option index:', slabIndex);
    }

    if (slabTable) {
      slabTable.innerHTML = slabs.map(function (s) {
        var v = findVariant(chosenOptions(s.value));
        var active = slab && s.value === slab.value ? ' class="is-active"' : '';
        return '<tr' + active + '><td>' + s.value + '</td><td>' + (v ? formatMoney(v.price) : '-') + '</td></tr>';
      }).join('');
    }

    if (hintBox) {
      var next = slabs.find(function (s) { return s.min > qty; });
      var nextVariant = next && findVariant(chosenOptions(next.value));
      if (next && nextVariant && variant && nextVariant.price < variant.price) {
        hintBox.innerHTML = config.strings.hint
          .replace('[qty]', next.min - qty)
          .replace('[price]', formatMoney(nextVariant.price));
      } else {
        hintBox.innerHTML = '';
      }
    }
  }

  form.querySelectorAll('[data-gh-qty-step]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var step = parseInt(btn.getAttribute('data-gh-qty-step'), 10);
      qtyInput.value = Math.max(minQty, getQty() + step);
      update();
    });
  });
  qtyInput.addEventListener('input', update);
  qtyInput.addEventListener('change', function () {
    if (getQty() < minQty) qtyInput.value = minQty;
    update();
  });
  form.querySelectorAll('[data-gh-option]').forEach(function (input) {
    input.addEventListener('change', update);
  });

  // ---------- Live card preview ----------
  function formatDate(value) {
    var parts = value.split('-');
    return parts.length === 3 ? parts[2] + '-' + parts[1] + '-' + parts[0] : value;
  }

  function setPreview(key, text) {
    document.querySelectorAll('[data-gh-preview="' + key + '"]').forEach(function (el) {
      el.textContent = text;
    });
  }

  form.querySelectorAll('[data-gh-text]').forEach(function (input) {
    var key = input.getAttribute('data-gh-text');
    var placeholder = document.querySelector('[data-gh-preview="' + key + '"]');
    var fallback = placeholder ? placeholder.textContent : '';
    var sync = function () {
      var value = input.value.trim();
      if (key === 'date') value = formatDate(value);
      setPreview(key, value || fallback);
    };
    input.addEventListener('input', sync);
    sync();
  });

  form.querySelectorAll('[data-gh-pick]').forEach(function (select) {
    var key = select.getAttribute('data-gh-pick');
    var thumb = form.querySelector('[data-gh-thumb="' + key + '"]');
    var sync = function () {
      var option = select.options[select.selectedIndex];
      if (!option) return;
      setPreview(key, option.value);
      if (thumb && option.getAttribute('data-img')) thumb.src = option.getAttribute('data-img');
    };
    select.addEventListener('change', sync);
    sync();
  });

  var counter = form.querySelector('[data-gh-count]');
  var counterOut = form.querySelector('[data-gh-count-out]');
  if (counter && counterOut) {
    var count = function () { counterOut.textContent = counter.value.length; };
    counter.addEventListener('input', count);
    count();
  }

  var logoInput = form.querySelector('[data-gh-logo]');
  var logoPreview = document.querySelector('[data-gh-preview-logo]');
  if (logoInput && logoPreview) {
    logoInput.addEventListener('change', function () {
      var file = logoInput.files[0];
      if (!file) return;
      var reader = new FileReader();
      reader.onload = function (e) {
        logoPreview.innerHTML = '';
        var img = document.createElement('img');
        img.src = e.target.result;
        img.alt = '';
        logoPreview.appendChild(img);
      };
      reader.readAsDataURL(file);
    });
  }

  // ---------- Add to cart ----------
  function showError(message) {
    errorBox.textContent = message;
    errorBox.hidden = !message;
  }

  function validate() {
    var valid = true;
    form.querySelectorAll('[required]').forEach(function (field) {
      var filled = field.type === 'file' ? field.files.length > 0 : field.value.trim() !== '';
      field.classList.toggle('is-invalid', !filled);
      if (!filled) valid = false;
    });
    if (!valid) {
      showError(config.strings.required);
      return false;
    }
    if (getQty() < minQty) {
      showError(config.strings.minQty.replace('[qty]', minQty));
      return false;
    }
    return true;
  }

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    showError('');
    update();
    if (!validate() || submitBtn.disabled) return;

    var data = new FormData(form);
    // Drop UI-only fields and empty optional properties so they don't show up in the order
    Array.from(data.keys()).forEach(function (key) {
      if (key.indexOf('gh-option-') === 0) data.delete(key);
    });
    form.querySelectorAll('[name^="properties["]').forEach(function (field) {
      if (field.type === 'file') {
        if (!field.files.length) data.delete(field.name);
      } else if (!field.value.trim()) {
        data.delete(field.name);
      } else if (field.type === 'date') {
        data.set(field.name, formatDate(field.value));
      }
    });

    submitBtn.disabled = true;
    submitBtn.innerHTML = config.strings.adding;

    fetch(config.cartAddUrl, {
      method: 'POST',
      body: data,
      headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' }
    })
      .then(function (res) {
        return res.json().then(function (json) {
          if (!res.ok) throw new Error(json.description || json.message || 'Error');
          window.location.href = config.cartUrl;
        });
      })
      .catch(function (err) {
        showError(err.message);
        submitBtn.disabled = false;
        submitBtn.innerHTML = buttonText;
      });
  });

  update();
})();
